const utils = require("Sources/utils/utils");

module.exports = class Product
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.abstractKey = options["abstract-key"];
    this.key = options.key;
    this.name = options.name;
    this.meta = options.meta;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/product.js